import { gql } from 'graphql-request'

export const REMOVE_ADMINS = gql`
  mutation RemoveAdmins($removeAdminsInput: RemoveAdminInput!) {
    removeAdmins(removeAdminsInput: $removeAdminsInput) {
      message
    }
  }
`
